import { CdkDragMove, CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, ElementRef, Input, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormGroup, FormBuilder, FormArray } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ContentManagementService, ICourseMainTopic } from 'src/app/Services/content-management/content-management.service';
import { FlashCardManagementService } from 'src/app/Services/flashcard-management.service';
import { ConstantVars } from 'src/app/utils/constants/constants';
import { IStudyUnitDisplayOrder } from '../study-unit-display-order/study-unit-display-order.component';
import { get } from 'jquery';
import { CourseMainTopicAddEditComponent } from '../course-main-topic-add-edit/course-main-topic-add-edit.component';
import { IGetCodes } from 'src/app/interfaces/codes';

@Component({
  selector: 'app-study-unit-main-topic-display-order',
  templateUrl: './study-unit-main-topic-display-order.component.html',
  styleUrls: ['./study-unit-main-topic-display-order.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class StudyUnitMainTopicDisplayOrderComponent implements OnInit {
  @Input() SubjectId: number;
  @Input() courseId: number;
  courseMainTopics: ICourseMainTopic[];
  displayForm: FormGroup;
  path: string;

  @ViewChild('scrollArea', { static: true })
  scrollArea!: ElementRef<HTMLElement>;

  private rafId: number | null = null;
  mainTopicstatusTypeCode: IGetCodes[];

  constructor(
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    public service: ContentManagementService,
    private toastr: ToastrService,
    private modalService: NgbModal
  ) {}

  ngOnInit(): void {
    this.displayForm = this.fb.group({
      sortOrder: this.fb.array([]),
    });

    this.getCourseMainTopic();
  }







  addFormGroup(value: ICourseMainTopic) {
  return this.fb.group({
    courseMainTopicId: [{ value: value.Course_Main_Topic_Id || '', disabled: true }],
    courseMainTopicName: [{ value: value.Course_Main_Topic_Name || '', disabled: true }],
    courseName: [{ value: value.Course_Name || '', disabled: true }],
    ExamAgencyName: [{ value: value.Exam_agency_Name || '', disabled: true }],
    examYear: [{ value: value.Exam_Year || '', disabled: true }],
    courseMainTopicStatusTypeCode: [
      { value: value.Course_Main_Topic_Status_Type_Code || '', disabled: true },
    ],
    displayOrder: [{ value: value.Display_Order || 0, disabled: true }],
    deleteInd: [{value:value.Deleted_Ind || 'N', disabled: true}],
    subjectId: [{ value: value.Subject_ID || '', disabled: true }],
    subjectName: [{ value: value.Subject_Name || '', disabled: true }],
    majorTopicId: [{ value: value.Major_Topic_ID || '', disabled: true }],
    majorTopicName: [{ value: value.Major_Topic_Name || '', disabled: true }],
    courseMainTopicSubjectId: [{ value: value.Course_Main_Topic_Subject_Id || '', disabled: true }],
    examAgencyId: [{ value: value.Exam_agency_ID || '', disabled: true }],
    courseId: [{ value: value.Course_ID || '', disabled: true }],
    examShortName: [{ value: value.Exam_Short_Name || '', disabled: true }],
  });
}

  edit(item:{
  courseMainTopicId: number | string | null;
  courseMainTopicName: string | null;
  courseName: string | null;
  ExamAgencyName: string | null;
  examYear: number | string | null;
  courseMainTopicStatusTypeCode: string | null;
  displayOrder: number;
}){
  const modalRef = this.modalService.open(CourseMainTopicAddEditComponent, {
      centered: true,
      size: 'lg',
      backdrop: 'static'
    });
    modalRef.componentInstance.item= item
    modalRef.componentInstance.Screen ='MAIN_TOPIC_DISPLAY_ORDER'
    modalRef.result.then(
      (result:any) => {
        console.log('Saved payload:', result);
        // handle saved result
        this.activeModal.close();
      },
      (reason:any) => {
        console.log('Modal dismissed');
      }
    );


  }

    async deleteTopic(item:{
  courseMainTopicId: number | string | null;
  courseMainTopicName: string | null;
  courseName: string | null;
  ExamAgencyName: string | null;
  examYear: number | string | null;
  courseMainTopicStatusTypeCode: string | null;
  displayOrder: number;
},index:number){

  this.DisplayArray.at(index).get('deleteInd')?.setValue('Y')

  }


  onDragMoved(event: CdkDragMove) {
  if (this.rafId !== null) return; // throttle to animation frame

  this.rafId = requestAnimationFrame(() => {
    const container = this.scrollArea.nativeElement;
    const rect = container.getBoundingClientRect();
    const y = event.pointerPosition.y;

    const threshold = 60; // px from top/bottom to start scrolling
    const step = 30;      // px per frame

    if (y < rect.top + threshold) {
      container.scrollTop -= step;
    } else if (y > rect.bottom - threshold) {
      container.scrollTop += step;
    }
    this.rafId = null;
  });
}

  getCourseMainTopic() {
    const payload = {
      CourseID:+this.courseId,
      SubjectID:+this.SubjectId,
      CourseMainTopicID:null,
      CourseMainTopicStatusTypeCode:null,
      MajorTopicID:null
     };

    this.service.getCourseMainTopicDisplayOrder(payload).subscribe(
      (res) => {
        console.log(res);
        if (res && Array.isArray(res)) {
          // ✅ Ensure response is valid
          this.courseMainTopics = res;

          if (!this.DisplayArray) {
            this.displayForm.setControl('sortOrder', this.fb.array([]));
          }

          this.DisplayArray.clear(); // ✅ Clear previous data
          this.courseMainTopics.filter((e)=>e.Deleted_Ind!=='Y').forEach((e) => {
            this.DisplayArray.push(this.addFormGroup(e));
          });
        }
      },
      (error) => {
        console.error('Error fetching study units:', error);
      }
    );
  }

  get DisplayArray(): FormArray {
    return (
      (this.displayForm?.get('sortOrder') as FormArray) || this.fb.array([])
    ); // ✅ Ensure FormArray exists
  }

  drop(event: CdkDragDrop<FormArray>) {
    moveItemInArray(
      this.DisplayArray.controls,
      event.previousIndex,
      event.currentIndex
    );

    // ✅ Update Display Order after sorting
    this.DisplayArray.controls.forEach((control, index) => {
      control.get('displayOrder')?.setValue(index + 1);
    });
  }

  onSave() {
    console.log(this.DisplayArray.value,'sasd');
    const UDT = this.DisplayArray.value.map((e:any)=>{
      const payload ={
      CourseMainTopicID:e.courseMainTopicId,
      DisplayOrder: e.displayOrder,
      DeletedInd:e.deleteInd,
    }
    return payload
      })

      const payload= {
        CourseID: +this.courseId,
        UDTCourseMainTopicDisplayOrder: UDT,
      }
    this.service.UpdateCourseMainTopicDisplayOrder(payload).subscribe(
    (res)=>{
      this.toastr.success('DisplayOrder Changed Successfully','Success',{timeOut:500})
    this.activeModal.close();

    },
    (err)=>{}
    )


  }
  onCross() {
    this.activeModal.close(false);
  }
}
